import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable, Subscription } from 'rxjs/Rx';
import { NotificationsService } from 'angular2-notifications';

import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { ModalService } from 'app/shared/modal/modal.service';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { AlterarSenhaService } from '../alterar-senha/alterar-senha.service';
import { SITE_KEY } from '../recaptcha-info';
import { RecaptchaService } from '../recaptcha.service';
import { HttpClient } from '@angular/common/http';

const ROTA_AREA_RESTRITA = '/restrito';

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent {

  @Input() opcoesLogin = {
    tipoLogin: '',
    siglaSistema: '',
    contexto: '',
  };

  @Output() onSuccess = new EventEmitter();

  public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public cpf;
  public senha;
  public alterarSenha;
  public confirmarAlterarSenha;
  public erro = false;
  public erroMsg = '';
  public cpfValido = null;
  public forcarAlterarSenha = false;
  public carregando = false;
  public subsAlterarPessoa: Subscription;
  public siteKey: string = SITE_KEY;
  public successRecaptchaToken: boolean = false;



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pessoaService: PessoaService,
    private modalService: ModalService,
    private alterarSenhaService: AlterarSenhaService,
    private authenticationService: AuthenticationService,
    private notificacao: NotificationsService,
    private recacptchaService: RecaptchaService,
    private httpClient: HttpClient
  ) { }

  validaCpf() {
    if (this.cpf) {
      return this.cpfValido = this.pessoaService.validarCpf(this.cpf);
    }

    return this.cpfValido = null;
  }


  openRecuperarSenha() {

    this.modalService.open(`modal-recuperar-senha-${this.opcoesLogin.tipoLogin.toLowerCase()}`);
  }

  login(form: NgForm) {
    if (form.valid) {
      this.carregando = true;
      let sendValue = {
        username: this.cpf.replace(/\D+/g, ''),
        password: this.senha,
        //password: this.refatorarData(this.senha),
        tipoLogin: this.opcoesLogin.tipoLogin,
        siglaSistema: this.opcoesLogin.siglaSistema,
        contexto: this.opcoesLogin.contexto}


      this.authenticationService.login(sendValue)
        .subscribe(
          (loggedUser) => {
            if (loggedUser) {
              this.verificarSituacaoUsuario(loggedUser);
            }
            this.carregando = false;
          },
          error => {
            this.erro = true;
            this.erroMsg = error.msg;
            this.carregando = false;
          },
        );
    }
  }

  irAreaRestrita(perfil) {
    this.router.navigate([`${ROTA_AREA_RESTRITA}/${perfil}`], {
      relativeTo: this.route,
    });
  }

  verificarSituacaoUsuario(loggedUser) {

    if (loggedUser && this.opcoesLogin.tipoLogin === 'CONTRATANTE' && loggedUser.isSenhaGerada !== 'S') {

      return this.irAreaRestrita('contratante');

    }else if(loggedUser && this.opcoesLogin.tipoLogin === 'CONTRATANTE' && loggedUser.isSenhaGerada === 'S'){

      return this.irAreaRestrita('contratante/alterar-senha');
    }


    if (loggedUser.pessoa.isSenhaGerada === 'N' || !loggedUser.pessoa.isSenhaGerada) {

      this.irAreaRestrita(loggedUser.pessoa.perfil);
    } else {
      this.irAreaRestrita(loggedUser.pessoa.perfil);
      //this.forcarAlterarSenha = true;
    }
  }

  aoAlterarSenha(form: NgForm) {
    if (!form.valid) {
      return;
    }
    const { pessoa } = this.authenticationService.getLoggedUser();
    this.carregando = true;

    const pessoaObservable: Observable<any> = this.pessoaService.alterarSenha(
      pessoa.codigo,
      this.alterarSenha,
      this.senha,
      null,
      null
    );

    this.subsAlterarPessoa = pessoaObservable.subscribe(() => {
      this.carregando = false;
      this.notificacao.success('Sucesso', 'Sua senha foi alterada.');
      this.irAreaRestrita(pessoa.perfil);
    });

    pessoaObservable.catch((erro) => {
      this.carregando = false;
      return erro;
    });
  }

  refatorarData(dataDeEntrada: String){
    const dataFormatada = dataDeEntrada.slice(6,10) + '-' + dataDeEntrada.slice(3,5) + '-' + dataDeEntrada.slice(0,2);
    return dataFormatada;
  }

  handleCorrectCaptcha(event){
    const data = {
      token: event
    }
    this.recacptchaService.validateRecaptchaToken(data).subscribe((result) =>{
     this.successRecaptchaToken = result['success'];
    });

  }
}
